import styled from "styled-components";
import { ReactNode } from "react";
import {
  FieldGroup as FieldGroupComponent,
  getTypographyStyles,
  IPropsField
} from "@security-watchdog/sw-ui-kit";

export const FieldGroup = styled(FieldGroupComponent)<
  Omit<IPropsField, "label"> & { label: string | ReactNode }
>`
  margin-bottom: 23px;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const DateRangeWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const DatePickerWrapper = styled.div`
  max-width: 250px;
  flex: 2 1 146px;
`;

export const SubLabel = styled.label`
  ${getTypographyStyles({
    color: "color-text-subdued",
    variant: "body-wide-line"
  })};
`;
